import { z } from 'zod';
import { shiftWithAnalyticsAndMissionSchema } from './shiftCommonSchema';
const getPastShiftsResponseSchema = shiftWithAnalyticsAndMissionSchema.merge(z.object({
    permissions: z.string().array().optional(), // TODO: Change to required - CRMS-3034
}));
export const getPastShiftsFunctionDef = {
    name: 'getPastShifts',
    requestSchema: z.null(),
    responseSchema: getPastShiftsResponseSchema.array(),
};
